import React from 'react';

const StatusMessage = ({ message, type = 'success' }) => {
  return (
    <div className={`message ${message ? type : ""}`}>
      {message}
    </div>
  );
};

export default StatusMessage;